import { StarIcon } from 'lucide-react'

export type ReviewItem = {
  id: string
  rating: number
  review: string
  writeDate: string
}

export const ReviewItem = ({ rating, review, writeDate }: ReviewItem) => {
  const formatReviewDate = (date: string) => {
    const reviewDate = new Date(date)
    return `${reviewDate.getFullYear()}.${
      reviewDate.getMonth() + 1
    }.${reviewDate.getDate()}`
  }

  return (
    <div className="w-[243px] min-w-[243px] rounded-lg border p-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          <StarIcon fill="#ff6401" className="size-4 text-primary" />
          <span className="text-caption-01-semi">{rating}</span>
        </div>
        <span className="text-caption-01-regular text-gray-400">
          {formatReviewDate(writeDate)}
        </span>
      </div>
      <div className="mt-2">
        <p className="line-clamp-2 text-body-02-semi">{review}</p>
      </div>
    </div>
  )
}
